import abi from "./Tabenomics.json";

export const contractABI = abi.abi;
export const contractAddress = "0x7cF9fE4666Cb911F2e7376E70d964dEAf53Eb7c5";

